export default __webpack_public_path__ + "static/viz/media/postgresql-icon.9005c2e6.svg";